import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import RenewalProbabilityTable from "components/property-market/renewal-probability/renewal-probability-table"
// Data
import api_match from "data/interface/api"
import importService from "data/import"
import renewalProbabilityService from "data/renewal-probability"
import propertyService from 'data/property.ts'
import { alphanum } from "components/table/lib/sort"
//Styles
import { RenewalProbability_s } from "components/property-market/renewal-probability/renewal-probability-styles"
import { AddIcon } from "images/icons/tools"

const RenewalProbability: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const tableId = "renewal-probability-table"

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const renewalProbabilitySubscription = renewalProbabilityService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setData([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {
            setData(ok.value)
          }
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        setProperty(_.find(data.value, {propertyid: data.current}))
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    return function cleanup() {
      renewalProbabilitySubscription.unsubscribe()
      propertySubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    renewalProbabilityService.fetchRenewalProbability(propertyId)
    propertyService.fetchProperty(propertyId)

  }, [propertyId])

  const Add = () => {
    return (
      <a onClick={() => renewalProbabilityService.create(propertyService.getStoredPropertyId())}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <RenewalProbability_s>
      <Toolbar>
        <Add />
        <ImportIcon />
        <ExportIcon template="renewalprobability" />
      </Toolbar>
      { showImport && <Import /> }
      { data && property && !showImport && <RenewalProbabilityTable tableId={tableId} data={data} /> }
    </RenewalProbability_s>
  )
}

export default RenewalProbability
